import type React from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { TABLE_ROW_SIZE } from '../../../constants';
import { usePokerMultiTableTournamentsWidget } from '../../../model';

const useDynamicHeightFromRows = (ref: React.RefObject<HTMLDivElement | null>) => {
  const { widgetSelect } = usePokerMultiTableTournamentsWidget();
  const tableRowsCount = useSelector(widgetSelect.getTableRowsCount);

  useEffect(() => {
    if (ref.current) {
      let height = `${window.innerHeight}px`;
      const rowsHeight = tableRowsCount * TABLE_ROW_SIZE;
      if (rowsHeight < window.innerHeight) {
        height = getComputedStyle(document.documentElement).getPropertyValue(
          '--pageMainSectionHeight'
        );
      }
      ref.current.style.setProperty('height', height);
    }
  }, [ref, tableRowsCount]);
};

export default useDynamicHeightFromRows;
